<script>
  import * as PropTypes from "prop-types";
  const { checkPropTypes, string, array, number, bool } = PropTypes;
  import { onMount } from "svelte";
  export let src, srcset, sizes;
  export let source = [];
  export let alt = "";
  export let width = "100%";
  export let disabled = false;
  export let nw, nh;
  export let responsive = true;
  export let imageClass = "";
  export let objectFitClass = "";
  let clazz;
  export { clazz as class };

  const propTypes = {
    src: string,
    srcset: string,
    sizes: string,
    source: array,
    alt: string,
    width: string,
    disabled: bool,
    nw: number,
    nh: number,
    responsive: bool,
    imageClass: string,
    objectFitClass: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "LazyImage");
  });

  let aspectRatio = 100,
    attrs,
    sourceAttrs;
  if (nw && nh) {
    aspectRatio = (nh / nw) * 100;
  }
  $: {
    attrs = disabled
      ? {
          sizes,
          src,
          srcset,
        }
      : {
          sizes,
          "data-src": src,
          "data-srcset": srcset,
        };
  }
  $: {
    sourceAttrs = source.map((sr) =>
      disabled
        ? sr
        : {
            type: sr.type,
            sizes: sr.sizes,
            "data-srcset": sr.srcset,
            media: sr.media,
          }
    );
  }
</script>

{#if responsive}
  <div class={`relative ${clazz || ""}`} style={`width:${width}`}>
    <div class="w-full" style={`padding-bottom:${aspectRatio}%;`}>
      <picture>
        {#each sourceAttrs as sr, i (i)}
          <source {...sr} />
        {/each}
        <img
          {alt}
          {...attrs}
          class={`absolute top-0 left-0 w-full h-full ${
            disabled ? "" : "lazyload"
          } ${objectFitClass}`}
        />
      </picture>
    </div>
  </div>
{:else}
  <picture>
    {#each sourceAttrs as sr, i (i)}
      <source {...sr} />
    {/each}
    <img
      {alt}
      {...attrs}
      class={`absolute top-0 left-0 w-full h-full ${
        disabled ? "" : "lazyload"
      } ${imageClass} ${objectFitClass}`}
    />
  </picture>
{/if}
